import { render, staticRenderFns } from "./AttendedServices.vue?vue&type=template&id=5d1db2c0&scoped=true&"
import script from "./AttendedServices.vue?vue&type=script&lang=js&"
export * from "./AttendedServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1db2c0",
  null
  
)

export default component.exports